module.exports = __webpack_public_path__ + "img/AV.34ce61dd.png";